import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="pt-24 pb-12 px-6 md:px-12 bg-[#0a0e1a] text-[#f5f5f0]" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-3">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111827] rounded-2xl p-8 border-t-4 border-green-500/70" data-id="element-4">
            <h3 className="text-2xl font-bold mb-6 text-green-400" data-id="element-5">
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-6">
              {['Te controlas de día y te rompes de noche', "Sientes vergüenza y cansancio de 'empezar mañana'", 'Quieres algo práctico, corto, repetible'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-7">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-8" />
                  <span className="text-gray-300 text-lg" data-id="element-9">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111827] rounded-2xl p-8 border-t-4 border-red-500/70" data-id="element-10">
            <h3 className="text-2xl font-bold mb-6 text-red-400" data-id="element-11">
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-12">
              {["Buscas una dieta estricta o 'milagros'", 'Necesitas un tratamiento clínico y no estás dispuesto a pedir ayuda', 'Quieres una solución sin tocar entorno/hábitos'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-13">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-14" />
                  <span className="text-gray-300 text-lg" data-id="element-15">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}